<template>
    <div>
        <v-autocomplete
                v-model="record"
                :label="label"
                :items="records"
                item-value="id"
                item-text="name"
                outlined
                dense
                :multiple="multiple"
                :readonly="readonly"
                :clearable="!readonly"
                :color="inputColor"
                :background-color="backgroundColor"
                hide-details="auto"
                @input="input"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>


<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";


export default {
    name: 'StrWorkerDefAutocomplete',
    props: {
        value: [Number, Array],
        rules: Array,
        label: String,
        readonly: Boolean,
        resource: String,
        multiple: Boolean,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const record = ref(null);
        const records = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/${props.resource}`,).then(response => {
                records.value = response.data.sort((a, b) => a.name.localeCompare(b.name));
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => props.value, () => {
            record.value = props.value;
        }, {immediate: true});

        watch(() => props.resource, () => {
            findAll();
        }, {immediate: true});

        function input(value) {
            emit('input', value);
        }

        return {
            records,
            loading,
            inputColor,
            backgroundColor,
            record,
            input,
        }
    },
};
</script>